import type { MigrationStrategies } from "./_types/migration-strategies";

export const VTM_MIGRATION_STRATEGIES: MigrationStrategies = {
  1: (oldDoc) => oldDoc,
  2: (oldDoc) => oldDoc,
};
